module.exports = __webpack_public_path__ + "static/img/axxbpo01.fc6c73a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/axxbpo01.png
// module id = j6VP
// module chunks = 2